"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var UploadCloud = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_UploadCloud_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.461 5.417a.145.145 0 0 1-.119.109 2.766 2.766 0 0 0 .422 5.5h3.231a.51.51 0 0 0 0-1.019H2.764a1.746 1.746 0 0 1-.268-3.474c.464-.07.84-.414.953-.87a3.493 3.493 0 0 1 5.8-1.675c.305.292.744.396 1.147.272a1.747 1.747 0 0 1 2.23 1.349c.087.474.458.846.932.933a1.747 1.747 0 0 1-.322 3.465h-3.23a.51.51 0 0 0 0 1.02h3.23a2.766 2.766 0 0 0 .507-5.486.146.146 0 0 1-.117-.117 2.765 2.765 0 0 0-3.53-2.138.145.145 0 0 1-.143-.034A4.491 4.491 0 0 0 6.836 2a4.512 4.512 0 0 0-4.375 3.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86 8.363a.498.498 0 1 1-.706-.705l2.482-2.495a.497.497 0 0 1 .353-.147.497.497 0 0 1 .364.146l2.493 2.495a.5.5 0 0 1-.705.707L8.5 6.72v6.78a.499.499 0 1 1-.998 0V6.713L5.86 8.362Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_UploadCloud_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = UploadCloud;
exports["default"] = _default;